// Business Information Configuration
// Update these details with your actual business information

export const BUSINESS_INFO = {
  // Company Details
  name: 'The Perfect Peach Club',
  tagline: 'Ancient Wisdom, Modern Wellness',
  
  // Contact Information
  email: 'info@theperfectpeachclub.co.za',
  phone: '',
  whatsapp: '',
  
  // Social Media Handles — leave as empty string '' to hide the icon in the footer
  social: {
    instagram: 'https://www.instagram.com/theperfectpeachclub/',
    facebook: '',
    tiktok: 'https://www.tiktok.com/@theperfectpeachcl',
  },
  
  // Bank Account Details for Manual EFT Payments
  banking: {
    bankName: 'Capitec Bank',
    accountHolder: 'The Perfect Peach Club',
    accountNumber: '1234567890',
    branchCode: '470010',
    accountType: 'Business Current Account',
    reference: 'Order [ORDER_NUMBER]', // Customers should use their order number
  },
  
  // Business Address
  address: {
    street: '123 Wellness Avenue',
    city: 'Johannesburg',
    province: 'Gauteng',
    postalCode: '2000',
    country: 'South Africa',
  },
  
  // Shipping Information
  shipping: {
    processingTime: '1-2 business days',
    deliveryTime: '3-5 business days',
    freeShippingThreshold: 500, // Free shipping on orders over R500
    standardShippingFee: 75, // R75 standard shipping
  },
  
  // Legal Information
  legal: {
    registrationNumber: 'REG123456',
    vatNumber: 'VAT123456',
    termsUrl: '/terms-and-conditions',
    privacyUrl: '/privacy-policy',
  },
};

export default BUSINESS_INFO;
